import { forwardRef, PropsWithChildren } from 'react';
import { FilledButton, FilledButtonProps } from './filled-button';
import { OutlinedButton, OutlinedButtonProps } from './outlined-button';

type ButtonProps = FilledButtonProps | OutlinedButtonProps;

const Button = forwardRef<HTMLButtonElement, PropsWithChildren<ButtonProps>>(
  ({ children, variant, color, ...rest }, ref) => {
    switch (variant) {
      case 'filled':
        return (
          <FilledButton ref={ref} {...rest} variant={variant} color={color}>
            {children}
          </FilledButton>
        );
      case 'outlined':
        return (
          <OutlinedButton variant={variant} ref={ref} {...rest}>
            {children}
          </OutlinedButton>
        );
    }
  },
);

export default Button;
